import { IconButton } from '@mui/material'
import { Brightness4, Brightness7 } from '@mui/icons-material'
import { usePreferencesStore } from '../stores/preferencesStore'

interface ThemeToggleProps {
  onToggle?: () => void
}

export default function ThemeToggle({ onToggle }: ThemeToggleProps) {
  const { themeMode, setThemeMode } = usePreferencesStore()

  const isDark = themeMode === 'dark'

  const handleToggle = () => {
    const next = isDark ? 'light' : 'dark'
    setThemeMode(next)
    onToggle?.()
  }

  return (
    <IconButton color="inherit" onClick={handleToggle} title="Toggle theme">
      {isDark ? <Brightness7 /> : <Brightness4 />}
    </IconButton>
  )
}
